import { PaymentTypes } from '@grandvisionhq/api-client';
import { PaymentServiceProvider } from '@grandvisionhq/payments';

/**
 * The getGraphQLPaymentProviderName function is being used to CONVERT the name of
 * the `payment service provider`, that is received by the `createOrder` POST request
 * TO the `payment service provider` name of new getCartPaymentMethods query.
 *
 * @param {PaymentMethod} name - The name of the payment service provider.
 */ const getGraphQLPaymentProviderName = (name)=>{
    switch(name){
        case PaymentTypes.PaymentServiceProvider.Adyen:
            return PaymentServiceProvider.ADYEN;
        case PaymentTypes.PaymentServiceProvider.CashOnDelivery:
            return PaymentServiceProvider.CASH_ON_DELIVERY;
        case PaymentTypes.PaymentServiceProvider.Fake:
            return PaymentServiceProvider.FAKE;
        default:
            return undefined;
    }
};

export { getGraphQLPaymentProviderName };
//# sourceMappingURL=get-payment-provider-name.js.map
